import { render } from "./PatientFollow.vue?vue&type=template&id=575ea162&scoped=true"
import script from "./PatientFollow.vue?vue&type=script&lang=js"
export * from "./PatientFollow.vue?vue&type=script&lang=js"

import "./PatientFollow.vue?vue&type=style&index=0&id=575ea162&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-575ea162"]])

export default __exports__